import { Component, Input, OnInit } from '@angular/core';
import { BaseResultChartComponent } from '../base-result-chart-component.directive';
import { ChartType } from 'chart.js';
import { elEnergyChartData, elEnergyChartOptions } from '../../chart-options';

@Component({
  selector: 'psc-annual-hourly-chart',
  templateUrl: './annual-hourly-chart.component.html',
})
export class AnnualHourlyChartComponent extends BaseResultChartComponent implements OnInit {

  @Input() advanced: boolean = false;

  protected readonly elEnergyChartData = elEnergyChartData({ length: 24, labelMapFn: (_, i) => i + ' h' });
  protected readonly elEnergyChartOptions = elEnergyChartOptions();
  protected readonly elEnergyChartType: ChartType = 'line';
  showHiddenChart: boolean;


  override ngOnInit() {
    super.ngOnInit();
    this.subscribeToLabelTranslation('consumption', this.elEnergyChartData.datasets[0]);
    this.subscribeToLabelTranslation('production', this.elEnergyChartData.datasets[1]);

    this.subs.sink = this.resultChartsService.generateChartImageRequest.annualGraph.subscribe(
      () => {
        const hiddenChart = this.charts.get(1);

        hiddenChart?.chart?.canvas.toBlob(blob => {
          this.resultChartsService.chartImageGenerated.annualGraph.next(blob as Blob);
        }, 'image/png');

      },
    );
  }

  protected setChartData() {
    this.elEnergyChartData.datasets[0].data = this.solarCalculatorResult.hourlyAnnualConsumption;
    this.elEnergyChartData.datasets[1].data = this.solarCalculatorResult.hourlyAnnualProduction;
  }
}
